module.exports = __webpack_public_path__ + "img/logo-instituto.c1e7e4f6.png";